// HPP: once the main product photo has loaded, quietly fetch the other gallery photos
// (the colour images) one at a time at low priority, so a colour tap shows its photo at once.
// Uses each gallery image's own srcset and sizes, so the browser picks the same file the
// gallery will ask for later. Reads the page only; variant and cart behaviour are untouched.
(() => {
  if (window.hppVariantImagePreload) return;
  window.hppVariantImagePreload = true;

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  const shouldSkip = () => {
    if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return true;
    return window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches;
  };

  const waitForIdle = () =>
    new Promise((resolve) => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(resolve, { timeout: 2000 });
      } else {
        setTimeout(resolve, 200);
      }
    });

  const waitForLoad = (image) =>
    new Promise((resolve) => {
      if (image.complete) return resolve();
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
    });

  const imageKey = (image) => image.getAttribute('srcset') || image.getAttribute('src');

  const preload = (image) =>
    new Promise((resolve) => {
      const copy = new Image();
      copy.decoding = 'async';
      copy.fetchPriority = 'low';
      if (image.getAttribute('sizes')) copy.sizes = image.getAttribute('sizes');
      if (image.getAttribute('srcset')) copy.srcset = image.getAttribute('srcset');
      copy.onload = copy.onerror = () => resolve();
      copy.src = image.getAttribute('src');
    });

  const preloadGallery = async (gallery) => {
    const list = gallery.querySelector('[id^="Slider-Gallery"]');
    if (!list) return;

    const images = Array.from(list.querySelectorAll('.product__media-item .product__media img'));
    const mainImage = list.querySelector('.product__media-item.is-active .product__media img') || images[0];
    if (!mainImage) return;

    await waitForLoad(mainImage);

    const seen = new Set();
    for (const image of images) {
      const key = imageKey(image);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      if (image.complete && image.naturalWidth) continue;
      if (shouldSkip()) return;

      await waitForIdle();
      await preload(image);
    }
  };

  const init = () => {
    if (shouldSkip()) return;
    document.querySelectorAll('product-info[id^="MainProduct"] media-gallery').forEach(preloadGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
